import { Box } from '@mui/material';
import { useMemo } from 'react';

import { BasicModal } from '../../components/modal';
import { Loading } from '../../components/progress';
import { DATE_FORMAT, toDisplayDate } from '../../utils/date';
import { useDashboardContext } from '../dashboard/contexts';
import { useFacilityContext } from '../dashboard/contexts/FacilityProvider';
import PdfRenderer from './PdfRenderer';
import { PdfViewerModalProps } from './PdfViewerModal.types';

export default function PdfViewerModal({
  open,
  onClose = () => {},
  ...rest
}: PdfViewerModalProps) {
  const {
    state: { selectedFacility },
  } = useFacilityContext();
  const {
    state: {
      days: { selected: selectedDay },
      scenarios: { selected: selectedScenario, data: scenarioList },
    },
  } = useDashboardContext();

  const currShiftOption = useMemo(
    () => scenarioList.find((d) => d.id === selectedScenario),
    [scenarioList, selectedScenario]
  );
  return (
    <BasicModal open={open} onClose={onClose} {...rest}>
      <Box sx={{ width: '70vw', height: '80vh' }}>
        {/* <Box
          sx={{
            py: 1,
            px: 2,
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Box sx={{ cursor: 'pointer' }} onClick={onClose}>
            <CloseIcon />
          </Box>
        </Box> */}
        {selectedFacility &&
        selectedScenario &&
        (selectedDay || selectedDay === '') ? (
          <PdfRenderer
            title={`${selectedFacility} Shift Map ${toDisplayDate(new Date().toISOString(), DATE_FORMAT.DATE_ONLY_HIPHEN)}`}
            fileName={`${selectedFacility}_Shift_Map_${toDisplayDate(new Date().toISOString(), DATE_FORMAT.DATE_ONLY_HIPHEN)}`}
            onClose={onClose}
            facility={selectedFacility}
            scenario={selectedScenario}
            scenarioLabel={currShiftOption?.label || ''}
            day={selectedDay}
          />
        ) : (
          <Loading />
        )}
      </Box>
    </BasicModal>
  );
}
